// Delegate consent checks so AJAX drawer replacements and BSS button reuse remain supported.
(() => {
  const checkConsent = (event, drawer) => {
    const checkbox = drawer.querySelector('#CartDrawer-PayLaterConsent');
    if (checkbox?.checked) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const error = drawer.querySelector('#CartDrawer-PayLaterConsentError');
    if (error) error.hidden = false;
    if (checkbox) {
      checkbox.setAttribute('aria-invalid', 'true');
      checkbox.focus();
    }
  };

  window.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('#bss-b2b-net-term-button');
    const drawer = button?.closest('cart-drawer');
    if (drawer) checkConsent(event, drawer);
  }, true);

  window.addEventListener('change', (event) => {
    if (!(event.target instanceof Element) || event.target.id !== 'CartDrawer-PayLaterConsent') return;
    const drawer = event.target.closest('cart-drawer');
    if (!drawer || !event.target.checked) return;
    event.target.removeAttribute('aria-invalid');
    const error = drawer.querySelector('#CartDrawer-PayLaterConsentError');
    if (error) error.hidden = true;
  });

  const initConsentVisibility = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const syncVisibility = () => {
      const consent = drawer.querySelector('.abaca-pay-later-consent');
      if (!consent) return;
      const button = drawer.querySelector('#bss-b2b-net-term-button');
      let visible = Boolean(button);
      // Follow the actual BSS button/wrapper visibility, without duplicating eligibility rules.
      for (let element = button; element && visible; element = element.parentElement) {
        const style = window.getComputedStyle(element);
        if (element.hidden || element.getAttribute('aria-hidden') === 'true' ||
            style.display === 'none' || style.visibility === 'hidden' ||
            style.visibility === 'collapse' || Number(style.opacity) === 0) {
          visible = false;
        }
        if (element === drawer) break;
      }

      if (consent.hidden !== !visible) consent.hidden = !visible;
      if (!visible) {
        const error = drawer.querySelector('#CartDrawer-PayLaterConsentError');
        if (error && !error.hidden) error.hidden = true;
      }
    };

    let scheduled = false;
    const scheduleSync = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        syncVisibility();
      });
    };

    new MutationObserver(scheduleSync).observe(drawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
    });
    window.addEventListener('resize', scheduleSync);
    syncVisibility();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initConsentVisibility, { once: true });
  } else {
    initConsentVisibility();
  }
})();

if (window.BSS_B2B) {
  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    const SEL = '#bss-b2b-net-term-button';
    let ntButton = null; // nút đã có click listener

    const ensureNT = () => {
      const current = drawer.querySelector(SEL);
      if (!current) return;

      // Lần đầu: init 1 lần duy nhất
      if (!ntButton) {
        if (current.dataset.initialized === 'true') {
          ntButton = current;
          return;
        }
        BSS_B2B.nt.initFunction();
        document.dispatchEvent(new Event('bss_b2b:dom_ready'));
        ntButton = current;
        return;
      }

      // Theme render lại -> thay nút mới bằng nút đã init
      if (current !== ntButton) current.replaceWith(ntButton);
    };

    ensureNT();
    new MutationObserver(ensureNT).observe(drawer, { childList: true, subtree: true });
  }
}
